var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhanHeRis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#F6A447"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33083_160985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5652V21.5441H28.6642V11.5652H10ZM24.4279 18.6547C22.8707 19.4925 21.107 19.9313 19.3377 19.9313C17.5684 19.9313 15.8047 19.4868 14.2474 18.6547C14.1247 18.592 14.0633 18.4496 14.0967 18.3128L15.2912 13.4402C15.3135 13.3376 15.3916 13.2578 15.4865 13.2293C15.5814 13.1951 15.6874 13.2179 15.7656 13.2806C16.787 14.124 18.026 14.5686 19.3433 14.5686C20.6605 14.5686 21.894 14.124 22.9209 13.2806C22.9991 13.2179 23.1051 13.1951 23.2 13.2293C23.2949 13.2635 23.3674 13.3433 23.3953 13.4402L24.5898 18.3128C24.6065 18.4496 24.5451 18.5863 24.4279 18.6547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9421 18.2273C22.5189 18.9511 20.9282 19.3272 19.3319 19.3272C17.7356 19.3272 16.1449 18.9454 14.7217 18.2273L15.7487 14.0272C16.798 14.768 18.0538 15.167 19.3319 15.167C20.6101 15.167 21.8659 14.7623 22.9152 14.0272L23.9421 18.2273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6642 22.1539H10V24.878H28.6642V22.1539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 28.8045V32.4348H28.6642V28.8045H10ZM18.4447 31.2266C18.4447 31.3919 18.3107 31.5286 18.1488 31.5286H11.1833C11.0214 31.5286 10.8874 31.3919 10.8874 31.2266V30.0184C10.8874 29.8531 11.0214 29.7164 11.1833 29.7164H18.1488C18.3107 29.7164 18.4447 29.8531 18.4447 30.0184V31.2266ZM21.5535 31.5286C21.0623 31.5286 20.666 31.124 20.666 30.6225C20.666 30.121 21.0623 29.7164 21.5535 29.7164C22.0447 29.7164 22.4409 30.121 22.4409 30.6225C22.4409 31.124 22.0447 31.5286 21.5535 31.5286ZM24.2214 31.5286C23.7302 31.5286 23.334 31.124 23.334 30.6225C23.334 30.121 23.7302 29.7164 24.2214 29.7164C24.7126 29.7164 25.1088 30.121 25.1088 30.6225C25.1088 31.124 24.7126 31.5286 24.2214 31.5286ZM26.9395 31.5286C26.4484 31.5286 26.0521 31.124 26.0521 30.6225C26.0521 30.121 26.4484 29.7164 26.9395 29.7164C27.4307 29.7164 27.827 30.121 27.827 30.6225C27.827 31.124 27.4307 31.5286 26.9395 31.5286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7932 28.2004H16.876L17.356 25.4763H21.3076L21.7932 28.2004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2216 30.9246C24.385 30.9246 24.5174 30.7893 24.5174 30.6225C24.5174 30.4557 24.385 30.3205 24.2216 30.3205C24.0582 30.3205 23.9258 30.4557 23.9258 30.6225C23.9258 30.7893 24.0582 30.9246 24.2216 30.9246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5536 30.9246C21.717 30.9246 21.8494 30.7893 21.8494 30.6225C21.8494 30.4557 21.717 30.3205 21.5536 30.3205C21.3903 30.3205 21.2578 30.4557 21.2578 30.6225C21.2578 30.7893 21.3903 30.9246 21.5536 30.9246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9394 30.9246C27.1027 30.9246 27.2352 30.7893 27.2352 30.6225C27.2352 30.4557 27.1027 30.3205 26.9394 30.3205C26.776 30.3205 26.6436 30.4557 26.6436 30.6225C26.6436 30.7893 26.776 30.9246 26.9394 30.9246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8479 30.3205H11.4795V30.9246H17.8479V30.3205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4087 16.1016V29.5625C33.4087 30.4801 32.6775 31.2266 31.7789 31.2266C30.8803 31.2266 30.1492 30.4801 30.1492 29.5625V25.0262C30.1492 24.4962 29.764 24.0516 29.2617 23.9775V23.3678C30.0933 23.4418 30.7408 24.1599 30.7408 25.0262V29.5625C30.7408 30.1438 31.204 30.6225 31.7789 30.6225C32.3538 30.6225 32.8171 30.1495 32.8171 29.5625V16.1016H33.4087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0005 12.118C34.0005 12.2662 33.9447 12.403 33.8442 12.5112L33.4981 12.8646C33.4423 12.9216 33.4088 12.9957 33.4088 13.0811V15.5032H32.8172V13.0811C32.8172 13.0014 32.7837 12.9216 32.7279 12.8646L32.3819 12.5112C32.2814 12.4087 32.2256 12.2662 32.2256 12.118C32.2256 11.8103 32.4712 11.5652 32.767 11.5652H33.4591C33.7549 11.5652 34.0005 11.8103 34.0005 12.118Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33083_160985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20.8696,
    fill: "white",
    transform: "translate(10 11.5652)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhanHeRis);
export default __webpack_public_path__ + "static/media/PhanHeRIS.a04cebc9.svg";
export { ForwardRef as ReactComponent };